import { SearchListItem } from "client/Features/Search/SearchListItem";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { generateTrackingId } from "client/Misc/utils";
import { EgnyteListItem } from "client/Features/Layout/TitleBar/GlobalSearch/Items/EgnyteListItem";
import { TimeZone } from "client/DateAndTime/timezones";
import { useEgnyteNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useEgnyteNavigationHandler";
import { ReactElement } from "react";

export type EgnyteItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.EgnyteItem>;
	navigationIndex: number;
	onRemove: () => void;
	isMobile: boolean;
	timezone: TimeZone;
};

export const EgnyteItemView = (props: EgnyteItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove,
		isMobile,
		timezone
	} = props;

	const {
		extension,
		lastModifiedDate,
		locationUrl,
		modifiedBy,
		name,
		path,
		url
	} = item.egnyteItem;

	const executeHandler: () => void = useEgnyteNavigationHandler({
		url,
		recentlyOpenedItem: item,
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("egnyte-item", `|${url}`)}
		>
			<EgnyteListItem
				isMobile={isMobile}
				extension={extension}
				name={name}
				path={path}
				url={url}
				lastModifiedDate={lastModifiedDate}
				modifiedBy={modifiedBy}
				locationUrl={locationUrl}
				onRemove={onRemove}
				timezone={timezone}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
EgnyteItemView.displayName = "EgnyteItemView";